import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

//defaults and for testing environment
if (!window.authConfig) {
    window.authConfig = {
        callback_url: "https://www.google.com",
        client_id: "",
        client_name: "",
        company_name: "",
        country: "",
        creation_path: null,
        csrf_token: "test",
        customer_partner: "",
        email: "",
        error_message: null,
        fixed_portal_id: null,
        full_name: "",
        industry: "",
        partner: "",
        partner_portal_id: null,
        phone_number: "",
        redirect: true,
        portal_url: "dev.mygo1.com",
        scopes: [],
        totara_license: "",
        users_total: 0,
        admin_login_only: true,
        referrer: null,
        identity_group: null,
        one_time_token: null,
        portal: null,
        email_login_flow: null,
    };
}

export default new Vuex.Store({
  state: {
      // OAuth Specific
      callback_url: window.authConfig.callback_url || "https://www.google.com",
      client_name: window.authConfig.client_name || (window.authConfig.client_id === 'totara' ? 'Totara' : ''),
      csrf_token: window.authConfig.csrf_token || "test",

      // state params used for emailing/prefilling values in register form
      company_name: window.authConfig.company_name || "",
      country: window.authConfig.country || "",
      customer_partner: window.authConfig.customer_partner || "",
      email: window.authConfig.email || "",
      error_message: window.authConfig.error_message || null,
      full_name: window.authConfig.full_name || "",
      industry: window.authConfig.industry || "",
      phone_number: window.authConfig.phone_number || "",
      totara_license: isNaN(window.authConfig.totara_license) ? 0 : window.authConfig.totara_license,
      users_total: isNaN(window.authConfig.users_total) ? 0 : window.authConfig.users_total,

      // local authentication
      auth_session: null,
      client_id: window.authConfig.client_id || "",
      creation_path: window.authConfig.creation_path || null,
      partner_portal_id: window.authConfig.partner_portal_id || null,
      portal_url: window.authConfig.portal_url || null,
      fixed_portal_id: window.authConfig.fixed_portal_id || null,
      partner: window.authConfig.partner || (window.authConfig.client_id === 'totara' ? 'totara' : ''),
      scopes: window.authConfig.scopes || [],
      redirect: window.authConfig.redirect !== false,
      admin_login_only: window.authConfig.admin_login_only === undefined ? true : window.authConfig.admin_login_only,
      portal_root_domain: window.authConfig.portal_root_domain || "mygo1.com",
  },

  mutations: {
      login: (state, authSession) => {
        state.auth_session = authSession;
      },

      logout: state => {
        state.auth_session = null;
      }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js